import { Injectable } from "@angular/core";
import {
  ApiErrorResponse,
  ApiService,
  ApiSuccessResponse,
} from "../api/api.service";
import { WizardNfceService } from "../nfce/wizard/wizard-nfce.service";
import { CertificateA1 } from "src/app/models/NfceWizard/CertificateA1";
import { CompanyNfceInformation } from "src/app/models/NfceWizard/CompanyNfceInformation";

@Injectable({
  providedIn: "root",
})
export class AccountantService {
  constructor(
    private api: ApiService,
    private wizardNfceService: WizardNfceService
  ) {}

  async sendCode(email: string): Promise<any> {
    const r: ApiErrorResponse | ApiSuccessResponse<string> =
      await this.api.post(`/accountant/signup/send-accountant-code`, { email });

    if (!r.success) {
      throw r;
    }

    return r;
  }

  async sendSignup(email: string, code: string): Promise<any> {
    const r: ApiErrorResponse | ApiSuccessResponse<string> =
      await this.api.post(`/accountant/signup/validate-acess`, { email, code });

    if (!r.success) {
      throw r;
    }
    return r;
  }

  async validateAccountantGuid(guid: string): Promise<any> {
    const r: ApiErrorResponse | ApiSuccessResponse<string> = await this.api.post(
      `/accountant/signup/validate-accountant-guid`,
      { guid },
    );

    if (!r.success) {
      throw r;
    }

    return r;
  }

  async sendCertificate(certificate: CertificateA1, tokenOverride?: string): Promise<Date | null> {
    return await this.wizardNfceService.sendCertificate(certificate, tokenOverride);
  }

  async updateNfceInformation(nfceInfo: CompanyNfceInformation, tokenOverride?: string): Promise<any> {
    return await this.wizardNfceService.UpdateCompanyNfceInformation(nfceInfo, tokenOverride);
  }
}
